import React from 'react';
import { getColor } from '../../utils/getColor';
import CoursesBySemester from '../parts/CoursesBySemester';
import {
  CourseEnrollmentStates,
  CourseValidationType,
} from '../types/CourseValidationType';
import {
  CoursesBySemestersExtraCourse,
  CourseStatusTooltip,
  Semester,
  SemesterCourseWithValidation,
} from '../types/progress';

export interface CoursesBySemestersProps {
  extraCourses?: CoursesBySemestersExtraCourse[];
  semesters: Semester[];
  texts: {
    credits: string;
    convalidationToolTip: (data: CourseStatusTooltip) => string;
    degreeActivityType?: string;
    degreeActivityTooltip?: string;
  };
  getColor?: (
    state?: CourseEnrollmentStates | CourseValidationType,
  ) => string | undefined;
  onClick?: (semesterCourse: SemesterCourseWithValidation) => void;
}

export default function CoursesBySemesters({
  extraCourses,
  semesters,
  texts,
  onClick,
}: CoursesBySemestersProps) {
  return (
    <>
      <div
        className="g-progression d-flex w-100"
        style={{
          overflowX: 'auto',
          flexDirection: 'row',
          gap: 16,
          marginLeft: -16,
          marginRight: -16,
          paddingBottom: 16,
          paddingRight: 16,
          paddingLeft: 16,
        }}
      >
        {semesters.map((semester, index) => {
          return (
            <React.Fragment key={semester.id}>
              <CoursesBySemester
                {...semester}
                getColor={getColor}
                title={
                  semester.title ? semester.title : `${semester.semesterIndex}`
                }
                texts={texts}
                onClick={onClick}
                onClickInfoModal={() => {}}
                extraCourses={
                  semesters.length - 1 === index ? extraCourses : undefined
                }
              />
            </React.Fragment>
          );
        })}
      </div>
    </>
  );
}
